import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import AdminPage from "./pages/AdminPage";
import AdminPointsPage from "./pages/AdminPointsPage";
import { trackVisitSource } from "./lib/sourceTracking";

function App() {
  // Runs once per page load, on any page - captures utm_source/utm_campaign.
  useEffect(() => {
    trackVisitSource();
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/admin/points" element={<AdminPointsPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
